import { RouterProvider } from 'react-router';
import { AuthProvider } from './context/AuthContext';
import { router } from './routes';
import { Toaster } from 'sonner';
import { ToastProvider } from "./components/ui/toast-provider";


export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>

      <RouterProvider router={router} />
      <Toaster position="top-right" richColors />
      </ToastProvider>
    </AuthProvider>
  );
}